module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-9-966930d55b0ba70cfd340820b4eb5641.jpg";